import {beerManagerModes} from 'features/beersManager/typescript';
import {Beer} from 'typescript/models/Beer';

import AddBeersBody from './AddBeersBody/AddBeersBody';
import AddBeersHeader from './AddBeersHeader/AddBeersHeader';
import './AddBeersTable.scss';

interface IProps {
  beersList: Beer[];
}

const AddBeersTable = ({beersList}: IProps) => {
  return (
    <>
      <table data-testid={`beers-table-${beerManagerModes.addBeers}`} className="add-beers-table">
        <AddBeersHeader />
        <AddBeersBody beersList={beersList} />
      </table>
    </>
  );
};

export default AddBeersTable;
